<script>
import VehicleListingsBase from "@/components/VehicleListings/VehicleListingsBase.vue";

export default {
  name: "VehicleListingsNewlyAdded",
  extends: VehicleListingsBase,
  skipVehicleListingsAutoFetch: true, // We handle fetching ourselves after setting up filters
  mounted() {
    this.innerFilters = [
      {
        time_created: {
          gte: Math.floor((Date.now() - 48 * 60 * 60 * 1000) / 1000)
        }
      }
    ];
    this.innerSorting = [{ id: "desc", _score: "desc" }];
    this.getVehicles();
  }
};
</script>
